export enum BranchConditionOperand {
  QuestionAnswer = 'QuestionAnswer',
  QuestionScore = 'QuestionScore',
  QuestionSetScore = 'QuestionSetScore',
}
